type TAccountEmailState = {
  email: string | undefined;
  confirmed: boolean;
};

let state: TAccountEmailState = { email: undefined, confirmed: false };

/**
 * Mirrors AuthProvider's `accountEmail`/`accountEmailConfirmed` refs outside React - the
 * domain account email (set for both business and personal accounts, sourced from the
 * backend account record) isn't otherwise reachable from plain, non-hook code.
 */
export const accountEmailStore = {
  get: (): TAccountEmailState => state,
  set: (next: TAccountEmailState): void => {
    state = next;
  }
};
